import { _, ts } from '_core';

export const prepareDistributionData = (
  data: ts.types.widgets.TableData,
  tab: 'signal_' | 'pipeline_' | 'sp_pipeline_'
): ts.types.widgets.TableData => {
  const newData = data.map((item) => {
    const newItem = { date: item.date } as ts.types.widgets.TableData[number];
    Object.keys(item).forEach((key) => {
      if (key !== 'date') {
        let newKey = key.replace(tab, '');
        newKey = newKey.startsWith('Q') ? newKey : _.startCase(newKey);
        newItem[newKey] = item[key];
      }
    });
    return newItem;
  });

  return newData;
};
